import { useParams, useSearchParams } from "react-router-dom";
import CheckoutPlanClient from "./CheckoutPlanClient";

export default function CheckoutPlanPage() {
  const routerParams = useParams<{ planId?: string; tierId?: string; packageId?: string }>();
  const [searchParams] = useSearchParams();
  const planId = routerParams.planId || searchParams.get("planId") || "";
  const tierId = routerParams.tierId || searchParams.get("tierId") || "";
  const packageId = routerParams.packageId || searchParams.get("packageId") || "";
  const orgSlug = searchParams.get("org") || "";
  const wsSlug = searchParams.get("ws") || "";

  return (
    <CheckoutPlanClient
      planId={planId}
      tierId={tierId}
      packageId={packageId}
      orgSlug={orgSlug}
      wsSlug={wsSlug}
    />
  );
}
